import { TopPerformance, Cex, Mobile } from "src/assets";
import { TGalleryItem } from "src/components/Gallery";

type TSourceDimesions = {
  bottomLayerWidth: number;
  topLayerWidth: number;
  totalWidth: number;
  totalHeight: number;
  topOffset?: number;
};

const DIMESIONS: Record<string, TSourceDimesions> = {
  PERFORMANCE: {
    bottomLayerWidth: 1000,
    topLayerWidth: 307,
    totalWidth: 1000,
    totalHeight: 600,
  },

  MOBILE: {
    bottomLayerWidth: 1000,
    topLayerWidth: 307,
    totalWidth: 1000,
    totalHeight: 600,
  },

  CEX: {
    bottomLayerWidth: 1000,
    topLayerWidth: 307,
    totalWidth: 1000,
    totalHeight: 600,
  },
};

const getBottomLayerWidth = ({
  bottomLayerWidth,
  totalWidth,
}: TSourceDimesions) => `${Math.round((bottomLayerWidth / totalWidth) * 100)}%`;

const getRatio = ({ totalHeight, totalWidth }: TSourceDimesions) =>
  `${((totalHeight / totalWidth) * 100).toFixed(2)}%`;

export const FEATURE_GALLERY_ITEMS: TGalleryItem[] = [
  {
    id: 0,
    title: (
      <>
        Top performance <br /> & reliability
      </>
    ),
    imagesConfig: {
      layers: [
        {
          src: TopPerformance,
          top: 4,
          left: 0,
          width: getBottomLayerWidth(DIMESIONS.PERFORMANCE),
        },
      ],
      width: "100%",
      paddingTop: getRatio(DIMESIONS.PERFORMANCE),
    },
  },
  {
    id: 1,
    title: (
      <>
        Best-in-class <br /> mobile experience
      </>
    ),
    imagesConfig: {
      layers: [
        {
          src: Mobile,
          top: 4,
          left: 0,
          width: getBottomLayerWidth(DIMESIONS.MOBILE),
        },
      ],
      width: "100%",
      paddingTop: getRatio(DIMESIONS.MOBILE),
    },
  },
  {
    id: 2,
    title: (
      <>
        Advanced trading
        <br />
        tools
      </>
    ),
    imagesConfig: {
      layers: [
        {
          src: Cex,
          top: 4,
          left: 0,
          width: getBottomLayerWidth(DIMESIONS.CEX),
        },
      ],
      width: "100%",
      paddingTop: getRatio(DIMESIONS.CEX),
    },
  },
];
